/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import getSimpleHeaderConfig from './getSimpleHeaderConfig'
import getStatus from './getStatus'
import shouldDisplayScene from './shouldDisplayScene'

const getSimpleViewOptions = ({
  copy,
  router,
  pathname,
}: {
  copy: any
  router: AppRouterInstance
  pathname: string
}) => {
  const simpleHeaderConfig = getSimpleHeaderConfig({
    copy,
    router,
  })
  const status = getStatus({
    pathname,
  })
  const option = simpleHeaderConfig[status]

  return {
    onClickBack: option.onClick,
    displayBackButton: shouldDisplayScene(pathname) ?? true,
    textBackButton: option.text,
  }
}

export default getSimpleViewOptions
